import streamMessagesReducer from 'utils/messages/StreamMessage';
import timeSeriesReducer from 'utils/timeseries/timeSeriesUtils';
import {
    StreamMessageElement,
    KeyedStreamElement,
} from 'communication/types/StreamElement';
import { StreamElementType } from 'communication/types/StreamElementType';
import { IntraDayProfileStreamElementType } from 'communication/types/intraDayProfile/IntraDayProfileStreamElementType';
import {
    IntraDayProfileElement,
    IntraDayProfileDataElement,
} from 'communication/types/intraDayProfile/IntraDayProfileElement';

import { WidgetStreamState } from 'widgets/store/stream/WidgetStreamState';

import {
    initialIntraDayProfileStreamState,
    IntraDayProfileDataState,
} from './IntraDayProfileStreamDataState';
import {
    buildStreamSlice,
    WidgetStreamSliceActionPayloadType,
} from 'widgets/store/stream/streamSlice';
import { WidgetType } from 'widgets/WidgetType';
import { selectIntraDayProfileState } from 'widgets/intraDayProfile/store/selectors';

export const processStreamElement = (
    element: IntraDayProfileDataElement,
    nextState: WidgetStreamState<IntraDayProfileDataState>
) => {
    const nextDataState: IntraDayProfileDataState = nextState.data;
    timeSeriesReducer(
        element as KeyedStreamElement<StreamElementType>,
        nextDataState
    );

    if (element._c === IntraDayProfileStreamElementType.Status) {
        if (element.excRanges) {
            nextDataState.excRanges = element.excRanges;
        } else {
            delete nextDataState.excRanges;
        }
    }

    const updatedElement = mapMissingStatusElementToMessageElement(element);
    streamMessagesReducer(updatedElement as StreamMessageElement, nextState);
};

export const buildIntraDayProfileStreamSlice = () =>
    buildStreamSlice<
        IntraDayProfileDataState,
        IntraDayProfileDataElement,
        IntraDayProfileElement
    >(
        WidgetType.INTRA_DAY_PROFILE,
        selectIntraDayProfileState,
        initialIntraDayProfileStreamState,
        processStreamElement
    );

export type IntraDayProfileStreamPayloadType =
    WidgetStreamSliceActionPayloadType<IntraDayProfileDataElement>;

function mapMissingStatusElementToMessageElement(
    element: IntraDayProfileDataElement
): IntraDayProfileDataElement {
    const msgs = [];
    if (element._c === IntraDayProfileStreamElementType.Status) {
        if (element.symNotFound) {
            msgs.push({ t: `Symbols not found: ${element.symNotFound}` });
        }
        if (element.noADV) {
            msgs.push({ t: `No ADV for symbols: ${element.noADV}` });
        }
        if (element.noProfile) {
            msgs.push({ t: `No profile for symbols: ${element.noProfile}` });
        }
        if (element.excludedSym) {
            msgs.push({ t: `Symbols excluded: ${element.excludedSym}` });
        }
    }
    return msgs.length > 0
        ? {
              _c: StreamElementType.Msg,
              m: msgs,
          }
        : element;
}
